import React from 'react';

interface RedirectProps {
    fill?: string;
}

export const Redirect = ({ fill }: RedirectProps) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_3647_3651)">
                <path
                    d="M9.75 9.09737L10.9167 7.92639V14.917H1V6.75037C1 5.78203 1.7875 5.00037 2.75 5.00037H8.18729L7.01875 6.16703H2.75C2.42917 6.16703 2.16667 6.42953 2.16667 6.75037V13.7504H9.75V9.09737Z"
                    fill="#818998"
                />
                <path
                    d="M11.9068 2.94714L6.49919 2.94301L6.49919 4.1062L11.086 4.1062L4.87494 10.3172L5.70402 11.1463L11.9109 4.93941L11.9109 9.56743L13.0741 9.56743L13.0741 4.11445C13.0741 3.47099 12.5503 2.94714 11.9068 2.94714Z"
                    fill="#818998"
                />
            </g>
            <defs>
                <clipPath id="clip0_3647_3651">
                    <rect width="14" height="14" fill="white" transform="translate(1 1)" />
                </clipPath>
            </defs>
        </svg>
    );
};
